import {reactive} from 'vue'

export const config = reactive({
  siteName: 'Rifen',
  logo: '/img/logo-c.png',
  language: 'en-US',
  developmentMode: false
})
